import { render, staticRenderFns } from "./ReportTshirtOrder.vue?vue&type=template&id=280184ff"
import script from "./ReportTshirtOrder.vue?vue&type=script&lang=js"
export * from "./ReportTshirtOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports